import { render } from "./damage-tr.vue?vue&type=template&id=5d127fc1"
import script from "./damage-tr.vue?vue&type=script&lang=js"
export * from "./damage-tr.vue?vue&type=script&lang=js"

import "./damage-tr.vue?vue&type=style&index=0&id=5d127fc1&lang=css"
script.render = render

export default script